<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="form.name"
          name="label"
          :counter="255"
          :label="`${$t('FORM_BUILDER.LABEL')} *`"
          :error-messages="errors.name"
          :readonly="readonly"
          :rules="getRulesByName('name')"
          @input="updateValue('label', $event)"
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import '@ckeditor/ckeditor5-build-decoupled-document/build/translations/de';
import formEditable from '@/modules/_global/mixins/form-editable';
import { notEmpty, maxLength } from '@/modules/_global/variables/rules';

export default {
  name: 'SingleEditLanguagesForm',

  mixins: [formEditable],

  props: {
    languageId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      form: {
        name: '',
        language_id: this.languageId
      },
      rules: {
        name: [notEmpty, maxLength(255)]
      }
    };
  },

  computed: {

  },

  methods: {

  }
};
</script>
